import {
  Group, Mesh, PlaneGeometry, ShaderMaterial, SphereGeometry,
  MeshBasicMaterial, DoubleSide,
} from "three";
import vert from "../shaders/higgs_field.vert?raw";
import frag from "../shaders/higgs_field.frag?raw";
import { detectFromBrowser, settingsForTier } from "../engine/tier";
import type { Chapter } from "./index";

export function createCh3Higgs(): Chapter {
  const group = new Group();
  const settings = settingsForTier(detectFromBrowser());

  const seg = settings.higgsSegments;
  const plane = new Mesh(
    new PlaneGeometry(20, 20, seg, seg),
    new ShaderMaterial({
      vertexShader: vert,
      fragmentShader: frag,
      uniforms: { uTime: { value: 0 } },
      transparent: true,
      side: DoubleSide,
    }),
  );
  plane.rotation.x = -Math.PI / 2.5;
  plane.position.y = -1.5;
  group.add(plane);

  const massless = new Mesh(
    new SphereGeometry(0.1, 12, 12),
    new MeshBasicMaterial({ color: 0xfff0aa }),
  );
  const heavy = new Mesh(
    new SphereGeometry(0.18, 16, 16),
    new MeshBasicMaterial({ color: 0xff66aa }),
  );
  group.add(massless, heavy);

  group.visible = false;

  return {
    id: 3,
    enter(ctx) { ctx.scene.add(group); group.visible = true; },
    exit(_ctx) { group.visible = false; },
    update(_ctx, t, _dt, local) {
      const mat = plane.material as ShaderMaterial;
      mat.uniforms.uTime.value = t;
      massless.position.set(-4 + local * 8, -0.9, 0);
      const heavyP = local * (0.5 + (1 - local) * 0.5);
      heavy.position.set(-4 + heavyP * 8, -1.0 - Math.sin(local * Math.PI) * 0.2, 0.5);
    },
  };
}
